"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nodeDefaultLoadOptions = exports.browserDefaultLoadOptions = void 0;
const baseDefaults = {
    path: "application.env",
    failSilently: false,
    validator: {},
};
exports.browserDefaultLoadOptions = Object.assign(Object.assign({}, baseDefaults), { path: "/application.env" });
exports.nodeDefaultLoadOptions = Object.assign(Object.assign({}, baseDefaults), { path: "application.env" });
//# sourceMappingURL=LoadOptions.js.map